import { ElMessage } from 'element-plus'

export const displayErrorMessages = (
  messages: Array<string>,
  defaultMessage?: string,
  duration = 3000
) => {
  if (messages.length) {
    messages.forEach((message) => {
      ElMessage.error({ message: message || defaultMessage, duration })
    })
  } else if (defaultMessage) {
    ElMessage.error({ message: defaultMessage, duration })
  }
}
